<div
  class="min-h-screen relative pb-16 font-['Poppins',_sans-serif] text-neutral-100 overflow-x-hidden selection:bg-neutral-800 selection:text-white bg-[url('/assets/background/bg.png')] bg-cover bg-center bg-no-repeat bg-fixed"
>
  <!-- Dynamic Background Elements (Optional Overlay) -->
  <div
    class="fixed inset-0 pointer-events-none z-0 overflow-hidden bg-black/20"
  >
    <div
      class="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-blue-500/10 blur-[80px]"
    ></div>
    <div
      class="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] rounded-full bg-pink-500/10 blur-[100px]"
    ></div>
  </div>

  @if (isLoading && !sessionData) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30"
    >
      <div class="flex flex-col items-center gap-4">
        <div
          class="w-12 h-12 border-4 border-white/20 border-t-pink-400 rounded-full animate-spin shadow-lg"
        ></div>
        <p
          class="text-white font-medium animate-pulse tracking-wide drop-shadow-md"
        >
          Memuat Momen...
        </p>
      </div>
    </div>
  }

  @if (sessionData || !isLoading) {
    <div
      class="relative z-10 w-full max-w-sm sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl mx-auto px-4 sm:px-8 pt-5 sm:pt-12 flex flex-col items-center animate-fade-in pb-16"
    >
      <!-- Top Logo Section -->
      <div
        class="mb-6 sm:mb-8 md:mb-12 w-full flex justify-center drop-shadow-md"
      >
        <img
          src="/assets/queue-monitoring/logo_fotokapsul.svg"
          alt="Fotokapsul Logo"
          class="h-14 sm:h-20 md:h-28 lg:h-36 xl:h-44 w-auto object-contain drop-shadow-xl"
        />
      </div>

      <!-- Dynamic QR / printable order identity -->
      <div
        id="order-qr-card"
        class="bg-white/95 backdrop-blur-sm rounded-[24px] sm:rounded-[36px] md:rounded-[48px] p-5 sm:p-9 md:p-12 lg:p-14 shadow-[0_10px_35px_rgb(0,0,0,0.15)] border border-white w-full max-w-xs sm:max-w-[480px] md:max-w-[640px] lg:max-w-[780px] xl:max-w-[880px] mb-8 flex flex-col items-center relative overflow-hidden"
      >
        <!-- Sparkle Ornaments -->
        <div
          class="absolute top-3 right-4 sm:top-7 sm:right-10 text-pink-300 text-xs sm:text-2xl lg:text-3xl"
        >
          ✦
        </div>
        <div
          class="absolute bottom-3 left-4 sm:bottom-7 sm:left-10 text-blue-300 text-xs sm:text-2xl lg:text-3xl"
        >
          ✦
        </div>

        <!-- Top Title with Lines -->
        <div
          class="flex items-center w-full justify-center mb-4 sm:mb-8 mt-1 sm:mt-3 z-10"
        >
          <div
            class="h-[1.5px] sm:h-[3px] bg-blue-200 flex-1"
          ></div>
          <div
            class="flex items-center gap-1.5 sm:gap-3 px-4 sm:px-8 py-1.5 sm:py-3 bg-white rounded-full mx-3 sm:mx-6 border border-blue-100 shadow-sm relative"
          >
            <!-- Glow behind the pill -->
            <div
              class="absolute inset-0 bg-blue-100 rounded-full blur-md opacity-30 -z-10"
            ></div>

            <div
              class="w-5 h-5 sm:w-9 sm:h-9 md:w-11 md:h-11 rounded-full bg-pink-50 flex items-center justify-center border border-pink-100 shadow-sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 text-pink-500"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                />
              </svg>
            </div>
            <span
              class="text-xs sm:text-xl md:text-2xl font-extrabold text-blue-700 tracking-wide"
              >PIN Akses</span
            >
          </div>
          <div
            class="h-[1.5px] sm:h-[3px] bg-blue-200 flex-1"
          ></div>
        </div>

        <!-- PIN Number -->
        <p
          class="text-3xl sm:text-5xl md:text-7xl lg:text-8xl leading-none font-black tracking-wider sm:tracking-[0.2em] text-[#0047cc] my-3 sm:my-6 text-center z-10 relative break-all"
          style="text-shadow: 0px 4px 18px rgba(37, 99, 235, 0.25)"
          aria-label="PIN order"
        >
          {{ order.order_pin || "-" }}
        </p>

        <!-- Info Text -->
        <p
          class="text-xs sm:text-lg md:text-xl font-bold text-neutral-400 mb-1 sm:mb-3 z-10 text-center"
        >
          Gunakan PIN ini untuk akses hasil fotomu
        </p>
      </div>

      <!-- Main Content Card -->
      <div
        class="bg-white rounded-[24px] sm:rounded-[36px] md:rounded-[48px] p-5 sm:p-9 md:p-12 lg:p-14 shadow-xl w-full flex flex-col items-center mb-8 border border-white"
      >
        <!-- Title -->
        <div class="flex items-center gap-1.5 sm:gap-2 mb-1.5 sm:mb-2 mt-0.5">
          <span class="text-pink-400 text-xl sm:text-3xl lg:text-4xl">✦</span>
          <h2
            class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-blue-600 flex gap-1.5 sm:gap-2"
          >
            Fotokapsul <span class="text-pink-400">Moments</span>
          </h2>
          <span class="text-blue-400 text-xl sm:text-3xl lg:text-4xl">✦</span>
        </div>

        <!-- Location -->
        <div
          class="flex items-center justify-center gap-1.5 sm:gap-2 mb-6 sm:mb-9 text-neutral-700 text-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4 sm:w-6 sm:h-6 text-pink-400 flex-shrink-0"
          >
            <path
              fill-rule="evenodd"
              d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
              clip-rule="evenodd"
            />
          </svg>
          <span
            class="font-bold text-xs sm:text-lg md:text-xl text-neutral-700"
            >{{
              sessionData?.order?.company?.name || "Fotokapsul Summarecon"
            }}</span
          >
        </div>

        <!-- Vertical Flow Photo Content: Soft Files TOP, Framed Photos BOTTOM -->
        <div class="w-full flex flex-col gap-7 sm:gap-12 mb-6 sm:mb-8">
          <!-- SECTION 1: Soft Files Foto (Full Width & Scaled Height) -->
          <div class="w-full flex flex-col gap-3 sm:gap-4">
            <div class="flex items-center justify-between px-0.5 mb-0.5">
              <span
                class="text-xs sm:text-lg md:text-xl font-bold text-neutral-800 flex items-center gap-1.5 sm:gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 sm:w-7 sm:h-7 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                Soft Files Foto
              </span>
              <span
                class="text-[10px] sm:text-sm font-bold text-blue-600 bg-blue-50 border border-blue-100 px-3 py-1 rounded-full"
              >
                {{ softFiles.length }} Foto
              </span>
            </div>

            <div
              class="w-full max-h-[250px] sm:max-h-[400px] md:max-h-[540px] lg:max-h-[680px] overflow-y-auto pr-1 [&::-webkit-scrollbar]:w-1.5 sm:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar-thumb]:rounded-full"
            >
              @if (softFiles && softFiles.length > 0) {
                <div
                  class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-2.5 sm:gap-4 md:gap-5"
                >
                  @for (photo of softFiles; track photo.id || $index) {
                    <div
                      (click)="openModal(photo)"
                      class="w-full aspect-[3/4] bg-neutral-100 rounded-lg sm:rounded-2xl overflow-hidden border border-neutral-200 cursor-pointer group relative shadow-sm hover:shadow-xl transition-all duration-300 flex items-center justify-center p-0.5"
                    >
                      <img
                        [src]="photo.url"
                        class="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                        [class.opacity-50]="!isFileAuthorized(photo)"
                      />
                      @if (!isFileAuthorized(photo)) {
                        <div
                          class="absolute inset-0 flex items-center justify-center bg-black/40 p-1 text-center backdrop-blur-[1px]"
                        >
                          <div
                            class="bg-black/70 p-2 sm:p-3 rounded-full border border-white/30 shadow-lg flex items-center justify-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="w-4 h-4 sm:w-6 sm:h-6 text-pink-400"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </div>
                        </div>
                      }
                      @if (isFileAuthorized(photo)) {
                        <div
                          class="absolute bottom-1.5 left-1.5 right-1.5 text-center bg-emerald-500/95 text-white text-[8px] sm:text-xs font-extrabold rounded-lg py-0.5 shadow-md backdrop-blur-sm"
                        >
                          TERBUKA
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div
                  class="w-full py-10 sm:py-16 bg-neutral-50 rounded-2xl border border-dashed border-blue-200 flex flex-col items-center justify-center gap-3 px-4"
                >
                  <img
                    src="/assets/queue-join/foto_limit_habis.png"
                    alt="Belum ada foto"
                    class="w-24 h-24 sm:w-36 sm:h-36 md:w-40 md:h-40 object-contain mb-1 drop-shadow-md"
                  />
                  <p
                    class="text-sm sm:text-xl font-extrabold text-neutral-600 text-center"
                  >
                    Belum ada foto yang bisa didownload
                  </p>
                  <p
                    class="text-xs sm:text-sm font-medium text-neutral-400 text-center max-w-xs"
                  >
                    Foto kamu sedang diproses. Tunggu sebentar ya, akan segera
                    muncul di sini! 📸
                  </p>
                </div>
              }
            </div>
          </div>

          <!-- Divider -->
          <div class="w-full border-t border-dashed border-neutral-200"></div>

          <!-- SECTION 2: Foto AI (AI Photos) -->
          @if (aiPhotos && aiPhotos.length > 0) {
            <div class="w-full flex flex-col gap-3 sm:gap-4">
              <div class="flex items-center justify-between px-0.5 mb-0.5">
                <span
                  class="text-xs sm:text-lg md:text-xl font-bold text-neutral-800 flex items-center gap-1.5 sm:gap-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 sm:w-7 sm:h-7 text-[#44A1A4]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z"
                    />
                  </svg>
                  Hasil Foto AI (AI Photo)
                </span>
                <span
                  class="text-[10px] sm:text-sm font-bold text-[#44A1A4] bg-[#44A1A4]/10 border border-[#44A1A4]/20 px-3 py-1 rounded-full"
                >
                  {{ aiPhotos.length }} Foto AI
                </span>
              </div>

              <div class="w-full">
                <div
                  class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-2.5 sm:gap-4 md:gap-5"
                >
                  @for (photo of aiPhotos; track photo.id || $index) {
                    <div
                      (click)="openModal(photo)"
                      class="w-full aspect-[3/4] bg-[#44A1A4]/10 rounded-lg sm:rounded-2xl overflow-hidden border border-[#44A1A4]/30 cursor-pointer group relative shadow-sm hover:shadow-xl transition-all duration-300 flex items-center justify-center p-0.5"
                    >
                      <img
                        [src]="photo.url"
                        class="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300 rounded-md sm:rounded-xl"
                      />
                      <div
                        class="absolute bottom-1.5 left-1.5 right-1.5 text-center bg-[#44A1A4] text-white text-[8px] sm:text-xs font-extrabold rounded-lg py-0.5 shadow-md backdrop-blur-sm"
                      >
                        FOTO AI
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Divider -->
            <div class="w-full border-t border-dashed border-neutral-200"></div>
          }

          <!-- SECTION 2.5: Fotoin Aja Matches -->
          @if (isUltimaProduct && fotoinAjaMatches && fotoinAjaMatches.length > 0) {
            <div class="w-full flex flex-col gap-3 sm:gap-4">
              <div class="flex items-center justify-between px-0.5 mb-0.5">
                <span
                  class="text-xs sm:text-lg md:text-xl font-bold text-neutral-800 flex items-center gap-1.5 sm:gap-2"
                >
                  <img
                    src="/assets/logo/FOTOINAJA.png"
                    alt="FotoinAja Logo"
                    class="h-5 sm:h-8 w-auto object-contain"
                  />
                  Hasil Fotoin Aja
                </span>
                <span
                  class="text-[10px] sm:text-sm font-bold text-[#FF8A00] bg-[#FF8A00]/10 border border-[#FF8A00]/20 px-3 py-1 rounded-full"
                >
                  {{ fotoinAjaMatches.length }} Foto
                </span>
              </div>

              <div class="w-full">
                <div
                  class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-2.5 sm:gap-4 md:gap-5"
                >
                  @for (match of fotoinAjaMatches; track match.matched_photo_id || $index) {
                    <div
                      (click)="openModal(match)"
                      class="w-full aspect-[3/4] bg-[#FF8A00]/10 rounded-lg sm:rounded-2xl overflow-hidden border border-[#FF8A00]/30 cursor-pointer group relative shadow-sm hover:shadow-xl transition-all duration-300 flex items-center justify-center p-0.5"
                    >
                      <img
                        [src]="match.matched_thumbnail || match.matched_file"
                        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 rounded-md sm:rounded-xl"
                      />
                      <div
                        class="absolute bottom-1.5 left-1.5 right-1.5 text-center bg-[#FF8A00] text-white text-[8px] sm:text-xs font-extrabold rounded-lg py-0.5 shadow-md backdrop-blur-sm"
                      >
                        FOTOIN AJA
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Divider -->
            <div class="w-full border-t border-dashed border-neutral-200"></div>
          }

          <!-- SECTION 3: Framed Photo Section (Full Width Scaled Height Cards) -->
          <div class="w-full flex flex-col gap-3 sm:gap-4">
            <div class="flex items-center justify-between px-0.5 mb-0.5">
              <span
                class="text-xs sm:text-lg md:text-xl font-bold text-neutral-800 flex items-center gap-1.5 sm:gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 sm:w-7 sm:h-7 text-pink-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
                  />
                </svg>
                Hasil Edit Foto (Framed Photo)
              </span>
              <span
                class="text-[10px] sm:text-sm font-bold text-pink-600 bg-pink-50 border border-pink-100 px-3 py-1 rounded-full"
              >
                {{ framedPhotos.length }} Foto
              </span>
            </div>

            <div class="w-full">
              @if (framedPhotos && framedPhotos.length > 0) {
                <div
                  [class]="
                    framedPhotos.length === 1
                      ? 'w-full flex justify-center'
                      : 'w-full flex gap-3.5 sm:gap-5 overflow-x-auto snap-x snap-mandatory [&::-webkit-scrollbar]:h-1.5 sm:[&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar-thumb]:rounded-full items-start pb-3'
                  "
                >
                  @for (framed of framedPhotos; track framed.id || $index) {
                    <div
                      (click)="
                        openFramedModal(
                          framed.url,
                          framed.name || 'framed_photo.jpg'
                        )
                      "
                      [class]="
                        framedPhotos.length === 1
                          ? 'w-full max-w-lg bg-neutral-100/90 rounded-2xl sm:rounded-3xl p-2 sm:p-3 overflow-hidden border border-neutral-200 shadow-md hover:shadow-2xl cursor-pointer group relative flex flex-col items-center justify-center transition-all duration-300'
                          : 'w-[85%] sm:w-[60%] md:w-[48%] max-w-md bg-neutral-100/90 rounded-xl sm:rounded-3xl p-2 sm:p-3 overflow-hidden border border-neutral-200 shadow-md hover:shadow-2xl cursor-pointer group relative flex-shrink-0 snap-center snap-always flex flex-col items-center justify-center transition-all duration-300'
                      "
                    >
                      <img
                        [src]="framed.url"
                        class="w-full h-auto max-h-[520px] sm:max-h-[700px] object-contain group-hover:scale-[1.02] transition-transform duration-500 rounded-lg sm:rounded-2xl"
                      />
                      <div
                        class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center p-3 sm:p-4 rounded-xl sm:rounded-3xl"
                      >
                        <span
                          class="text-white text-[10px] sm:text-base font-extrabold bg-black/70 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full backdrop-blur-md shadow-lg border border-white/20"
                        >
                          Klik Untuk Memperbesar Foto
                        </span>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div
                  class="w-full py-10 sm:py-16 bg-neutral-50 rounded-2xl border border-dashed border-pink-200 flex flex-col items-center justify-center gap-3 px-4 flex-shrink-0"
                >
                  <img
                    src="/assets/queue-join/foto_limit_habis.png"
                    alt="Belum ada foto"
                    class="w-24 h-24 sm:w-36 sm:h-36 md:w-40 md:h-40 object-contain mb-1 drop-shadow-md"
                  />
                  <p
                    class="text-sm sm:text-xl font-extrabold text-neutral-600 text-center"
                  >
                    Belum ada hasil cetak foto
                  </p>
                  <p
                    class="text-xs sm:text-sm font-medium text-neutral-400 text-center max-w-xs"
                  >
                    Hasil cetak foto (framed photo) kamu belum tersedia. Akan
                    muncul setelah sesi foto selesai! 🖼️
                  </p>
                </div>
              }
            </div>
          </div>

          <!-- SECTION 4: Video Clips -->
          @if (false && videoClips && videoClips.length > 0) {
            <div class="w-full border-t border-dashed border-neutral-200 -mt-2 sm:-mt-4"></div>
            <div class="w-full flex flex-col gap-3 sm:gap-4">
              <div class="flex items-center justify-between px-0.5 mb-0.5">
                <span
                  class="text-xs sm:text-lg md:text-xl font-bold text-neutral-800 flex items-center gap-1.5 sm:gap-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 sm:w-7 sm:h-7 text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />
                  </svg>
                  Video Clips
                </span>
                <span
                  class="text-[10px] sm:text-sm font-bold text-blue-600 bg-blue-50 border border-blue-100 px-3 py-1 rounded-full"
                >
                  {{ videoClips.length }} Video
                </span>
              </div>

              <div class="w-full">
                <div
                  [class]="
                    videoClips.length === 1
                      ? 'w-full flex justify-center'
                      : 'w-full flex gap-3.5 sm:gap-5 overflow-x-auto snap-x snap-mandatory [&::-webkit-scrollbar]:h-1.5 sm:[&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar-thumb]:rounded-full items-start pb-3'
                  "
                >
                  @for (video of videoClips; track video.id || $index) {
                    <div
                      [class]="
                        videoClips.length === 1
                          ? 'w-full max-w-lg bg-neutral-100/90 rounded-2xl sm:rounded-3xl p-2 sm:p-3 overflow-hidden border border-neutral-200 shadow-md flex flex-col items-center justify-center'
                          : 'w-[85%] sm:w-[60%] md:w-[48%] max-w-md bg-neutral-100/90 rounded-xl sm:rounded-3xl p-2 sm:p-3 overflow-hidden border border-neutral-200 shadow-md flex-shrink-0 snap-center snap-always flex flex-col items-center justify-center'
                      "
                    >
                      @if (!isIosDevice()) {
                        <div class="relative w-full mb-2 sm:mb-3 flex items-center justify-center min-h-[250px] sm:min-h-[400px]">
                          @if (!videoLoadedState[video.id || $index]) {
                            <div class="absolute inset-0 flex items-center justify-center bg-neutral-200 rounded-lg sm:rounded-2xl animate-pulse">
                              <div class="w-8 h-8 sm:w-10 sm:h-10 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin"></div>
                            </div>
                          }
                          <video
                            class="w-full h-auto max-h-[520px] sm:max-h-[700px] object-contain rounded-lg sm:rounded-2xl transition-opacity duration-500"
                            [class.opacity-0]="!videoLoadedState[video.id || $index]"
                            [class.opacity-100]="videoLoadedState[video.id || $index]"
                            (loadedmetadata)="videoLoadedState[video.id || $index] = true"
                            (loadeddata)="videoLoadedState[video.id || $index] = true"
                            (canplay)="videoLoadedState[video.id || $index] = true"
                            (error)="videoLoadedState[video.id || $index] = true"
                            autoplay
                            loop
                            muted
                            controls
                            playsinline="true"
                            webkit-playsinline="true"
                            preload="metadata"
                          >
                            <source [src]="video.url" type="video/mp4">
                            Browser Anda tidak mendukung tag video.
                          </video>
                        </div>
                      } @else {
                          <!-- Khusus iOS: Trik Blob via RAM untuk menghindari blokir S3 -->
                          @if (iosVideoLoading[video.id || $index] !== false && !iosVideoSafeUrls[video.id || $index]) {
                            <div class="absolute inset-0 flex flex-col items-center justify-center bg-black/5 animate-pulse rounded-lg sm:rounded-2xl min-h-[250px]">
                              <div class="w-8 h-8 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin mb-3"></div>
                              <span class="text-xs font-bold text-neutral-500">Menarik Video Khusus iPhone...</span>
                            </div>
                          }
                          @if (iosVideoSafeUrls[video.id || $index]) {
                            <video
                              class="w-full h-auto max-h-[520px] sm:max-h-[700px] object-contain rounded-lg sm:rounded-2xl"
                              controls
                              playsinline="true"
                              webkit-playsinline="true"
                              [src]="iosVideoSafeUrls[video.id || $index]"
                            ></video>
                          }
                      }
                      <button
                        type="button"
                        (click)="downloadVideo(video.url, video.name || 'video.mp4')"
                        class="w-full bg-blue-500 hover:bg-blue-600 text-white py-2.5 sm:py-3.5 px-4 rounded-xl font-bold text-xs sm:text-base flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-md shadow-blue-500/20"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4 sm:w-5 sm:h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2.5"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          />
                        </svg>
                        <span>Download Video</span>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Order actions -->
      <div class="w-full flex flex-col gap-3.5 mb-6">
        <!-- Main Download Buttons -->
        <div
          [class]="
            (aiPhotos.length > 0 && fotoinAjaMatches.length > 0)
              ? 'grid grid-cols-2 sm:grid-cols-4 gap-3 w-full'
              : (aiPhotos.length > 0 || fotoinAjaMatches.length > 0)
                ? 'grid grid-cols-1 sm:grid-cols-3 gap-3 w-full'
                : 'grid grid-cols-1 sm:grid-cols-2 gap-3 w-full'
          "
        >
          <!-- Button 1: Download Soft Files -->
          <button
            id="download-soft-files"
            type="button"
            (click)="downloadAllSoftFiles()"
            [disabled]="authorizedSoftFiles.length === 0"
            class="w-full bg-blue-500/90 backdrop-blur border border-blue-400 hover:bg-blue-600 disabled:bg-neutral-300 disabled:border-transparent disabled:text-neutral-500 text-white py-4 sm:py-5 px-5 rounded-xl sm:rounded-2xl font-black text-xs sm:text-base md:text-lg shadow-xl shadow-blue-500/20 hover:shadow-2xl hover:shadow-blue-500/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 sm:w-6 sm:h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Download Soft File ({{ authorizedSoftFiles.length }})</span>
          </button>

          <!-- Button 2: Download AI Photos -->
          @if (aiPhotos.length > 0) {
            <button
              id="download-ai-photos"
              type="button"
              (click)="downloadAllAiPhotos()"
              class="w-full bg-[#44A1A4] border border-[#44A1A4] hover:bg-[#368386] text-white py-4 sm:py-5 px-5 rounded-xl sm:rounded-2xl font-black text-xs sm:text-base md:text-lg shadow-xl shadow-[#44A1A4]/20 hover:shadow-2xl hover:shadow-[#44A1A4]/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 sm:w-6 sm:h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"
                />
              </svg>
              <span>Download Foto AI ({{ aiPhotos.length }})</span>
            </button>
          }

          <!-- Button 2.5: Download Fotoin Aja -->
          @if (isUltimaProduct && fotoinAjaMatches && fotoinAjaMatches.length > 0) {
            <button
              id="download-fotoin-aja"
              type="button"
              (click)="downloadAllFotoinAja()"
              class="w-full bg-[#FF8A00] border border-[#FF8A00] hover:bg-[#E67A00] text-white py-4 sm:py-5 px-5 rounded-xl sm:rounded-2xl font-black text-xs sm:text-base md:text-lg shadow-xl shadow-[#FF8A00]/20 hover:shadow-2xl hover:shadow-[#FF8A00]/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 sm:w-6 sm:h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              <span>Download Fotoin Aja ({{ fotoinAjaMatches.length }})</span>
            </button>
          }

          <!-- Button 3: Download Framed Photos (Direct download, no lock) -->
          <button
            id="download-framed-photos"
            type="button"
            (click)="downloadAllFramedPhotos()"
            [disabled]="framedPhotos.length === 0"
            class="w-full bg-pink-500/90 backdrop-blur border border-pink-400 hover:bg-pink-600 disabled:bg-neutral-300 disabled:border-transparent disabled:text-neutral-500 text-white py-4 sm:py-5 px-5 rounded-xl sm:rounded-2xl font-black text-xs sm:text-base md:text-lg shadow-xl shadow-pink-500/20 hover:shadow-2xl hover:shadow-pink-500/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 sm:w-6 sm:h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
            <span>Download Framed ({{ framedPhotos.length }})</span>
          </button>
        </div>

        <!-- Button 4: Download Complete Zip (Framed + Soft Files + AI + Fotoin Aja) -->
        @if (authorizedSoftFiles.length > 0 || framedPhotos.length > 0 || aiPhotos.length > 0 || fotoinAjaMatches.length > 0) {
          <button
            id="download-all-files"
            type="button"
            (click)="downloadAllMoments()"
            class="w-full bg-white hover:bg-neutral-50 border border-white/80 py-3.5 sm:py-4.5 px-6 rounded-xl sm:rounded-2xl font-extrabold text-xs sm:text-base shadow-xl hover:shadow-2xl active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 sm:w-5 sm:h-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
              />
            </svg>
            <span class="flex items-center gap-1 font-extrabold">
              <span class="text-blue-600">Download Semua Foto</span>
              <span class="text-pink-500 flex items-center gap-1">
                (Soft File + @if (aiPhotos.length > 0) { AI + } @if (fotoinAjaMatches.length > 0) { Fotoin Aja + } Framed)
              </span>
            </span>
          </button>
        }

        @if (lockedSoftFiles.length > 0) {
          <div class="w-full flex flex-col gap-3">
            <button
              id="redeem-photos-limit"
              type="button"
              (click)="redeemPhotosLimit()"
              [disabled]="isRedeeming"
              class="w-full bg-[#44A1A4] hover:bg-[#368386] text-white py-3.5 sm:py-4.5 md:py-5.5 px-4 sm:px-6 rounded-xl sm:rounded-2xl font-black shadow-md active:scale-[0.98] transition-all flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-3"
            >
              <div class="flex items-center gap-2 text-left">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="currentColor"
                  class="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span
                  class="leading-tight font-extrabold text-sm sm:text-lg md:text-xl text-left whitespace-normal break-words"
                >
                  @if (softFileRemaining > 0) {
                    Klaim Foto Sesuai Limit ({{ maxRedeemableCount }} Foto)
                  } @else {
                    Klaim Foto Sesuai Limit (Tersisa 0)
                  }
                </span>
              </div>
              <span
                class="text-xs sm:text-sm font-extrabold bg-white/20 px-3 py-1 rounded-full text-white whitespace-nowrap self-start sm:self-auto flex-shrink-0"
              >
                Tersisa {{ softFileRemaining }}
              </span>
            </button>

            <button
              id="buy-all-softfiles"
              type="button"
              (click)="openCheckout('all')"
              class="w-full bg-white border-2 border-blue-500 text-blue-600 py-3.5 sm:py-4.5 md:py-5.5 px-4 sm:px-6 rounded-xl sm:rounded-2xl font-black shadow-md hover:bg-blue-50 active:scale-[0.98] transition-all flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-3"
            >
              <div class="flex items-center gap-2 text-left">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="currentColor"
                  class="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 text-blue-500"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                  />
                </svg>
                <span
                  class="leading-tight font-extrabold text-sm sm:text-lg md:text-xl text-left whitespace-normal break-words"
                >
                  Tebus Semua File Foto
                </span>
              </div>
              <div
                class="flex items-center justify-between sm:justify-end gap-2 w-full sm:w-auto pt-1.5 sm:pt-0 border-t sm:border-t-0 border-blue-100 flex-shrink-0"
              >
                <span
                  class="text-[10px] sm:text-xs bg-amber-100 text-amber-800 font-bold px-2.5 py-1 rounded-full border border-amber-200 whitespace-nowrap"
                  >Voucher / QRIS</span
                >
                <strong
                  class="whitespace-nowrap text-sm sm:text-lg md:text-xl text-blue-700"
                  >{{ formatPrice(allFilesPrice) }}</strong
                >
              </div>
            </button>
          </div>
        }
      </div>
      <p
        class="text-center text-xs sm:text-base text-white/90 font-semibold -mt-2 mb-8"
      >
        {{ authorizedSoftFiles.length }} terbuka ·
        {{ lockedSoftFiles.length }} terkunci
      </p>

      <!-- Separator -->
      <div
        class="w-full border-t-2 border-dashed border-neutral-200/40 mb-8"
      ></div>

      <!-- Mascot & Info Box -->
      <div
        class="w-full bg-white rounded-[24px] sm:rounded-[36px] md:rounded-[48px] p-5 sm:p-9 md:p-12 shadow-xl border-2 border-white flex flex-row items-center gap-4 sm:gap-8 md:gap-12 relative overflow-hidden"
      >
        <!-- Left Mascot Illustration -->
        <div
          class="w-20 sm:w-32 md:w-44 lg:w-52 h-24 sm:h-40 md:h-52 lg:h-60 relative flex-shrink-0 flex items-end justify-center pb-1"
        >
          <img
            src="assets/queue-monitoring/FotKap_abadikan momen terbaikmu.png"
            alt="Abadikan momen"
            class="w-full h-full object-contain"
          />
        </div>

        <!-- Right Info -->
        <div class="flex-1 min-w-0 flex flex-col gap-2 sm:gap-4">
          <div
            class="bg-pink-100 text-pink-600 text-xs sm:text-base md:text-lg font-extrabold px-3 sm:px-5 py-1 sm:py-2 rounded-full self-start mb-1 truncate max-w-full"
          >
            Kode: {{ sessionData?.order?.invoice || "FK-0000" }}
          </div>

          <div
            class="grid grid-cols-[16px_40px_1fr] sm:grid-cols-[24px_60px_1fr] md:grid-cols-[30px_80px_1fr] items-center gap-x-2 sm:gap-x-4 gap-y-2 sm:gap-y-4 text-xs sm:text-lg md:text-2xl font-semibold text-neutral-800"
          >
            <!-- Name -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="w-4 h-4 sm:w-6 sm:h-6 md:w-7 md:h-7 text-blue-500 flex-shrink-0"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              />
            </svg>
            <span class="text-neutral-600">Nama</span>
            <span class="truncate font-extrabold text-neutral-900"
              >: {{ sessionData?.order?.name || "-" }}</span
            >

            <!-- PIN -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="w-4 h-4 sm:w-6 sm:h-6 md:w-7 md:h-7 text-blue-500 flex-shrink-0"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
              />
            </svg>
            <span class="text-neutral-600">PIN</span>
            <span class="truncate uppercase font-extrabold text-neutral-900"
              >: {{ sessionData?.order?.order_pin || "-" }}</span
            >
          </div>
        </div>
      </div>

      <!-- Detail Transaksi Button -->
      <div class="w-full mt-6 sm:mt-12 mb-2 print-hidden">
        <button
          id="open-transaction-detail"
          type="button"
          (click)="openTransactionModal()"
          class="w-full bg-blue-500/90 backdrop-blur border border-blue-400 text-white py-3.5 sm:py-5.5 px-8 rounded-xl sm:rounded-2xl font-extrabold text-xs sm:text-xl shadow-xl flex items-center justify-center gap-2 hover:bg-blue-600 active:scale-[0.98] transition-all"
        >
          Detail Transaksi
        </button>
      </div>
    </div>
  }

  <!-- ========================================================= -->
  <!-- AUTO REVIEW MODAL - MUNCUL SETELAH HASIL FOTO TERSEDIA -->
  <!-- ========================================================= -->
  @if (isReviewModalOpen && reviewTargetSession) {
    <div
      class="fixed inset-0 z-[100] flex items-center justify-center bg-black/55 p-4 backdrop-blur-[2px] animate-fade-in"
      (click)="closeReviewModal()"
    >
      <div
        class="relative w-full max-w-[420px] overflow-hidden rounded-xl bg-white text-neutral-900 shadow-2xl"
        (click)="$event.stopPropagation()"
      >
        <!-- Close X -->
        <button
          type="button"
          aria-label="Tutup review"
          (click)="closeReviewModal()"
          [disabled]="isSubmittingReview"
          class="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full border-0 bg-transparent text-xl font-bold leading-none text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          ×
        </button>

        <!-- Header -->
        <div
          class="border-b border-neutral-100 px-6 pb-4 pt-6 text-center sm:px-7 sm:pb-5 sm:pt-7"
        >
          <h2
            class="m-0 text-xl font-bold leading-tight tracking-tight text-neutral-900 sm:text-2xl"
          >
            Beri Ulasan Anda
          </h2>

          <p
            class="mx-auto mt-1 max-w-[320px] text-sm font-semibold leading-normal text-neutral-600 sm:text-base"
          >
            Pada
            {{
              reviewTargetSession?.device?.name ||
                reviewTargetSession?.device_name ||
                "Photobooth"
            }}
          </p>
        </div>

        <!-- Body -->
        <div class="px-6 py-5 sm:px-7 sm:py-6">
          <h3
            class="m-0 text-center text-sm font-semibold leading-tight text-neutral-800 sm:text-base"
          >
            Rating Photobooth Kami:
          </h3>

          <!-- Stars -->
          <div
            class="mt-3 flex items-center justify-center gap-1 sm:mt-4"
          >
            @for (star of [1, 2, 3, 4, 5]; track star) {
              <button
                type="button"
                (click)="setReviewRating(star)"
                [attr.aria-label]="'Beri rating ' + star + ' bintang'"
                class="border-0 bg-transparent p-0.5 text-3xl leading-none transition-all duration-150 hover:scale-110 active:scale-95 sm:text-4xl"
                [class.text-amber-400]="star <= reviewRating"
                [class.text-neutral-400]="star > reviewRating"
              >
                ★
              </button>
            }
          </div>

          <label
            for="review-note"
            class="mb-2 mt-5 block text-center text-xs font-medium text-neutral-700 sm:mt-6 sm:text-sm"
          >
            Tinggalkan Catatan:
          </label>

          <textarea
            id="review-note"
            [(ngModel)]="reviewNote"
            rows="3"
            maxlength="1000"
            placeholder="Tulis ulasan Anda di sini..."
            class="min-h-[90px] w-full resize-none rounded-lg border border-neutral-300 bg-white px-3.5 py-2.5 text-sm text-neutral-900 outline-none transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-100 sm:min-h-[100px]"
          ></textarea>
        </div>

        <!-- Footer -->
        <div
          class="flex items-center justify-end gap-2.5 border-t border-neutral-100 bg-neutral-50/50 px-6 py-3.5 sm:px-7 sm:py-4"
        >
          <button
            type="button"
            (click)="closeReviewModal()"
            [disabled]="isSubmittingReview"
            class="rounded-lg bg-neutral-500 px-4 py-2 text-sm font-medium text-white transition-all hover:bg-neutral-600 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 sm:px-5 sm:py-2.5"
          >
            Tutup
          </button>

          <button
            type="button"
            (click)="submitReview()"
            [disabled]="reviewRating === 0 || isSubmittingReview"
            class="min-w-[90px] rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-all hover:bg-blue-700 active:scale-[0.98] disabled:cursor-not-allowed disabled:bg-blue-300 sm:min-w-[100px] sm:px-5 sm:py-2.5"
          >
            @if (isSubmittingReview) {
              Mengirim...
            } @else {
              Submit
            }
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Modal Popup for Full Screen Photo (Soft Files - Locked if not redeemed) -->
  @if (isModalOpen) {
    <div
      class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/95 backdrop-blur-md animate-fade-in p-4 overflow-y-auto"
      (touchstart)="handleTouchStart($event)"
      (touchend)="handleTouchEnd($event, false)"
    >
      <button
        (click)="closeModal()"
        class="absolute top-4 right-4 sm:top-8 sm:right-8 text-white/70 hover:text-white p-3 sm:p-4 rounded-full bg-neutral-900/60 hover:bg-neutral-800 transition-all focus:outline-none z-50 shadow-xl"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <!-- Prev Arrow Button -->
      @if (softFiles.length > 1) {
        <button
          (click)="prevPhoto($event)"
          class="absolute left-2 sm:left-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-5 rounded-full bg-black/50 hover:bg-black/80 transition-all z-50 shadow-2xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      }

      <!-- Next Arrow Button -->
      @if (softFiles.length > 1) {
        <button
          (click)="nextPhoto($event)"
          class="absolute right-2 sm:right-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-5 rounded-full bg-black/50 hover:bg-black/80 transition-all z-50 shadow-2xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      }

      <div
        class="relative z-50 max-w-full max-h-[65vh] sm:max-h-[72vh] px-2 sm:px-6 flex justify-center items-center animate-scale-in group my-auto"
        (click)="$event.stopPropagation()"
      >
        <img
          [src]="selectedPhotoUrl"
          class="max-w-full max-h-[65vh] sm:max-h-[72vh] object-contain rounded-xl sm:rounded-2xl shadow-2xl border border-neutral-800"
          [alt]="selectedPhotoName"
        />
      </div>
      <div
        class="mt-4 sm:mt-8 flex flex-col items-center gap-3 sm:gap-4 px-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl z-50 animate-scale-in"
        (click)="$event.stopPropagation()"
      >
        <!-- Number indicator -->
        <p
          class="text-white/80 text-xs sm:text-base md:text-lg font-bold tracking-widest"
        >
          {{ currentPhotoIndex + 1 }} / {{ softFiles.length }}
        </p>

        @if (isFileAuthorized(selectedFile)) {
          <button
            id="download-selected-file"
            type="button"
            (click)="downloadAuthorizedFile(selectedFile)"
            class="w-full bg-white text-black py-3.5 sm:py-5 md:py-6 px-6 sm:px-10 rounded-full font-black text-xs sm:text-base md:text-xl tracking-wide hover:bg-neutral-200 active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-2"
          >
            Download Photo
          </button>
        } @else {
          <div class="w-full flex flex-col sm:flex-row gap-2.5 sm:gap-3">
            @if (softFileRemaining > 0) {
              <button
                id="claim-single-photo-modal"
                type="button"
                (click)="redeemPhotos([selectedFile]); closeModal()"
                [disabled]="isRedeeming"
                class="w-full sm:w-1/2 bg-[#44A1A4] hover:bg-[#368386] text-white py-3.5 sm:py-4 px-3 sm:px-4 rounded-full font-black text-xs sm:text-base tracking-wide active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-1.5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>Klaim Foto Ini (Sisa {{ softFileRemaining }})</span>
              </button>
            }
            <button
              id="buy-all-softfiles-modal"
              type="button"
              (click)="openCheckout('all'); closeModal()"
              [class]="
                softFileRemaining > 0
                  ? 'w-full sm:w-1/2 bg-blue-500 text-white py-3.5 sm:py-4 px-4 rounded-full font-black text-xs sm:text-base tracking-wide hover:bg-blue-600 active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-2'
                  : 'w-full bg-blue-500 text-white py-3.5 sm:py-5 md:py-6 px-6 sm:px-10 rounded-full font-black text-xs sm:text-base md:text-xl tracking-wide hover:bg-blue-600 active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-2'
              "
            >
              Beli Semua Foto
            </button>
          </div>
        }
      </div>
      <div
        class="absolute inset-0 z-40 cursor-default"
        (click)="closeModal()"
      ></div>
    </div>
  }

  <!-- Modal Popup for Framed Photos (Always Unlocked) -->
  @if (isFramedModalOpen) {
    <div
      class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/95 backdrop-blur-md animate-fade-in p-4 overflow-y-auto"
      (touchstart)="handleTouchStart($event)"
      (touchend)="handleTouchEnd($event, true)"
    >
      <button
        (click)="closeFramedModal()"
        class="absolute top-4 right-4 sm:top-8 sm:right-8 text-white/70 hover:text-white p-3 sm:p-4 rounded-full bg-neutral-900/60 hover:bg-neutral-800 transition-all focus:outline-none z-50 shadow-xl"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <!-- Prev Arrow Button -->
      @if (framedPhotos.length > 1) {
        <button
          (click)="prevFramedPhoto($event)"
          class="absolute left-2 sm:left-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-5 rounded-full bg-black/50 hover:bg-black/80 transition-all z-50 shadow-2xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      }

      <!-- Next Arrow Button -->
      @if (framedPhotos.length > 1) {
        <button
          (click)="nextFramedPhoto($event)"
          class="absolute right-2 sm:right-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 sm:p-5 rounded-full bg-black/50 hover:bg-black/80 transition-all z-50 shadow-2xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      }

      <div
        class="relative z-50 max-w-full max-h-[65vh] sm:max-h-[72vh] px-2 sm:px-6 flex justify-center items-center animate-scale-in group my-auto"
        (click)="$event.stopPropagation()"
      >
        <img
          [src]="selectedFramedUrl"
          class="max-w-full max-h-[65vh] sm:max-h-[72vh] object-contain rounded-xl sm:rounded-2xl shadow-2xl border border-neutral-800"
          [alt]="selectedFramedName"
        />
      </div>
      <div
        class="mt-4 sm:mt-8 flex flex-col items-center gap-3 sm:gap-4 px-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl z-50 animate-scale-in"
        (click)="$event.stopPropagation()"
      >
        <!-- Number indicator -->
        <p
          class="text-white/80 text-xs sm:text-base md:text-lg font-bold tracking-widest"
        >
          {{ currentFramedIndex + 1 }} / {{ framedPhotos.length }}
        </p>
        <button
          (click)="downloadPhoto(selectedFramedUrl, selectedFramedName)"
          class="w-full bg-white text-black py-3.5 sm:py-5 md:py-6 px-6 sm:px-10 rounded-full font-black text-xs sm:text-base md:text-xl tracking-wide hover:bg-neutral-200 active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 sm:h-6 sm:h-6 md:h-7 md:w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
          Download Foto
        </button>
      </div>
      <div
        class="absolute inset-0 z-40 cursor-default"
        (click)="closeFramedModal()"
      ></div>
    </div>
  }

  <!-- Modal Select Soft Files to Claim According to Limit -->
  @if (isClaimLimitModalOpen) {
    <div
      class="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-6 bg-black/75 backdrop-blur-sm animate-fade-in"
      (click)="closeClaimLimitModal()"
    >
      <div
        class="relative z-10 w-full max-w-2xl bg-white rounded-2xl sm:rounded-3xl shadow-2xl border border-neutral-100 p-5 sm:p-7 flex flex-col max-h-[90vh] animate-scale-in"
        (click)="$event.stopPropagation()"
      >
        <!-- Modal Header -->
        <div
          class="flex items-start justify-between border-b border-neutral-100 pb-4"
        >
          <div>
            <h3
              class="text-base sm:text-xl font-extrabold text-neutral-900 flex items-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 sm:w-6 sm:h-6 text-emerald-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Pilih Foto Sesuai Limit
            </h3>
            <p class="text-xs sm:text-sm text-neutral-500 mt-1">
              Pilih hingga
              <span class="font-bold text-emerald-600"
                >{{ softFileRemaining }} foto</span
              >
              yang ingin Anda buka terlebih dahulu.
            </p>
          </div>
          <button
            (click)="closeClaimLimitModal()"
            class="p-2 text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100 rounded-full transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 sm:w-6 sm:h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <!-- Limit Status Indicator -->
        <div
          class="my-3.5 px-4 py-2.5 bg-emerald-50 border border-emerald-200 rounded-xl flex items-center justify-between"
        >
          <span class="text-xs sm:text-sm font-bold text-emerald-800">
            Terpilih: {{ selectedRedeemFiles.length }} dari
            {{ softFileRemaining }} foto
          </span>
          <span
            class="text-[10px] sm:text-xs font-semibold px-2.5 py-0.5 rounded-full bg-emerald-200 text-emerald-900"
          >
            Sisa Quota: {{ softFileRemaining - selectedRedeemFiles.length }}
          </span>
        </div>

        <!-- Photo Selection Grid -->
        <div class="flex-1 overflow-y-auto pr-1 my-2">
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            @for (photo of lockedSoftFiles; track photo.id || $index) {
              <div
                (click)="toggleSelectRedeemFile(photo)"
                [class]="
                  isRedeemFileSelected(photo)
                    ? 'relative border-2 border-emerald-500 bg-emerald-50/30 rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer shadow-md ring-2 ring-emerald-500/50 transition-all duration-200 transform scale-[0.98]'
                    : 'relative border-2 border-neutral-200 hover:border-emerald-300 rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer shadow-sm hover:shadow-md transition-all duration-200'
                "
              >
                <!-- Checkbox Overlay Badge -->
                <div class="absolute top-2 right-2 z-10">
                  @if (isRedeemFileSelected(photo)) {
                    <div
                      class="w-6 h-6 sm:w-7 sm:h-7 bg-emerald-500 text-white rounded-full flex items-center justify-center shadow-lg animate-scale-in"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-4 h-4 sm:w-5 sm:h-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  } @else {
                    <div
                      class="w-6 h-6 sm:w-7 sm:h-7 bg-black/40 border-2 border-white text-white rounded-full flex items-center justify-center shadow-md backdrop-blur-sm"
                    ></div>
                  }
                </div>

                <!-- Photo Thumbnail -->
                <div
                  class="w-full aspect-[3/4] bg-neutral-100 flex items-center justify-center p-1"
                >
                  <img
                    [src]="photo.url"
                    class="w-full h-full object-contain rounded-lg"
                    [class.opacity-75]="!isRedeemFileSelected(photo)"
                  />
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Modal Footer Actions -->
        <div
          class="flex items-center justify-end gap-3 pt-4 border-t border-neutral-100 mt-2"
        >
          <button
            type="button"
            (click)="closeClaimLimitModal()"
            class="px-5 py-2.5 sm:py-3 rounded-xl border border-neutral-300 text-neutral-700 font-bold text-xs sm:text-sm hover:bg-neutral-100 active:scale-95 transition-all"
          >
            Batal
          </button>
          <button
            type="button"
            (click)="confirmRedeemSelected()"
            [disabled]="selectedRedeemFiles.length === 0 || isRedeeming"
            class="px-6 py-2.5 sm:py-3 rounded-xl bg-[#44A1A4] hover:bg-[#368386] disabled:bg-neutral-300 text-white font-extrabold text-xs sm:text-sm shadow-md hover:shadow-lg active:scale-95 transition-all flex items-center gap-2"
          >
            @if (isRedeeming) {
              <svg
                class="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>Memproses...</span>
            } @else {
              <span
                >Klaim ({{ selectedRedeemFiles.length }}) Foto Terpilih</span
              >
            }
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Shop / Packages Modal -->
  @if (isShopModalOpen) {
    <div class="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        class="absolute inset-0 bg-black/60 backdrop-blur-sm"
        (click)="closeShopModal()"
      ></div>
      <div
        class="relative bg-white rounded-3xl w-full max-w-md p-4 sm:p-6 shadow-2xl animate-fade-in-up flex flex-col items-center text-center"
      >
        <div
          class="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-blue-100 shrink-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 sm:h-10 sm:w-10 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
            />
          </svg>
        </div>

        <button
          (click)="closeShopModal()"
          class="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-700 bg-gray-100 rounded-full p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-1.5 sm:mb-2">
          Mau Bawa Pulang Lebih Banyak?
        </h3>
        <p class="text-xs sm:text-sm text-gray-500 mb-3.5 sm:mb-4">
          Pilih paket atau gunakan voucher untuk membuka foto momen spesial
          kamu!
        </p>

        <!-- Voucher Input Section -->
        <div
          class="w-full bg-amber-50 border border-amber-200 rounded-2xl p-3 sm:p-3.5 mb-4 text-left shadow-sm"
        >
          <label
            class="block text-xs font-bold text-amber-900 mb-1.5 flex items-center gap-1.5"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 text-amber-600 shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
              />
            </svg>
            Punya Kode Voucher?
          </label>

          @if (!appliedVoucher) {
            <div class="flex gap-2 w-full items-center">
              <input
                type="text"
                [(ngModel)]="voucherCodeInput"
                placeholder="Masukkan kode voucher"
                (keyup.enter)="applyVoucher()"
                class="flex-1 min-w-0 bg-white border border-amber-300 rounded-xl px-2.5 sm:px-3 py-2 text-[11px] sm:text-xs font-semibold text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 uppercase tracking-wider"
              />
              <button
                type="button"
                (click)="applyVoucher()"
                [disabled]="isApplyingVoucher || !voucherCodeInput.trim()"
                class="bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-white font-bold text-xs px-3 sm:px-4 py-2 rounded-xl transition-all shadow-sm flex items-center justify-center gap-1 whitespace-nowrap shrink-0"
              >
                @if (isApplyingVoucher) {
                  <span
                    class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"
                  ></span>
                } @else {
                  Klaim
                }
              </button>
            </div>
            @if (voucherError) {
              <p class="text-[11px] font-semibold text-red-600 mt-1.5">
                {{ voucherError }}
              </p>
            }
          } @else {
            <div
              class="flex items-center justify-between bg-emerald-100 border border-emerald-300 rounded-xl px-3 py-2"
            >
              <div class="flex items-center gap-2 min-w-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 text-emerald-600 shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <div class="flex flex-col text-left min-w-0">
                  <span
                    class="text-xs font-bold text-emerald-900 leading-tight break-words"
                  >
                    Voucher
                    <strong>{{ voucherCodeInput | uppercase }}</strong>
                    Diterapkan
                  </span>
                  @if (getVoucherDiscountText()) {
                    <span
                      class="text-[10px] sm:text-[11px] font-extrabold text-emerald-700 mt-0.5"
                    >
                      {{ getVoucherDiscountText() }}
                    </span>
                  }
                </div>
              </div>
              <button
                type="button"
                (click)="removeVoucher()"
                class="text-red-500 hover:text-red-700 text-xs font-bold px-2 py-1 shrink-0"
              >
                Batal
              </button>
            </div>
          }
        </div>

        @if (addonPackages.length > 0) {
          <div
            class="w-full flex flex-col gap-2.5 max-h-[40vh] overflow-y-auto mb-2 px-0.5"
            style="scrollbar-width: thin"
          >
            @for (pkg of addonPackages; track pkg.id) {
              <div
                class="bg-gray-50 border border-gray-200 rounded-xl p-2.5 sm:p-3 flex gap-2.5 sm:gap-3 text-left items-center cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all"
                (click)="buyAddon(pkg.id)"
              >
                <img
                  [src]="pkg.image || '/assets/image-placeholder.png'"
                  class="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-lg shadow-sm shrink-0"
                  [alt]="formatProductName(pkg.name)"
                />
                <div class="flex-1 min-w-0">
                  <h4
                    class="font-bold text-gray-900 text-xs sm:text-sm leading-snug mb-0.5 break-words"
                  >
                    {{ formatProductName(pkg.name) }}
                  </h4>
                  <p class="text-[10px] text-gray-500 mb-1 line-clamp-2">
                    {{ pkg.description }}
                  </p>
                  <div class="flex flex-wrap gap-1">
                    @for (perk of pkg.perks; track perk) {
                      <span
                        class="text-[9px] font-bold bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded"
                        >{{ perk }}</span
                      >
                    }
                  </div>
                </div>
                <div class="text-right shrink-0">
                  @if (
                    appliedVoucher &&
                    getDiscountedPrice(pkg.price, pkg.id).finalPrice < pkg.price
                  ) {
                    <div>
                      <span
                        class="line-through text-[10px] sm:text-xs text-gray-400 block font-normal leading-tight"
                        >Rp{{ pkg.price | number }}</span
                      >
                      @if (getDiscountedPrice(pkg.price, pkg.id).isFree) {
                        <span
                          class="text-emerald-600 font-black text-xs sm:text-base"
                          >GRATIS</span
                        >
                      } @else {
                        <span
                          class="text-blue-600 font-extrabold text-xs sm:text-base"
                          >Rp{{
                            getDiscountedPrice(pkg.price, pkg.id).finalPrice
                              | number
                          }}</span
                        >
                      }
                    </div>
                  } @else {
                    <div
                      class="font-bold text-blue-600 text-xs sm:text-base md:text-lg whitespace-nowrap"
                    >
                      Rp{{ pkg.price | number }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        } @else if (isAddonLoading) {
          <div class="py-4 text-center">
            <div
              class="animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent mx-auto mb-2"
            ></div>
            <p class="text-sm text-gray-500 italic">
              Mencari paket yang tersedia...
            </p>
          </div>
        } @else {
          <div class="py-4 text-center">
            <p class="text-sm text-gray-500 italic">
              Saat ini belum ada paket tambahan.
            </p>
          </div>
        }
      </div>
    </div>
  }

  <!-- Checkout confirmation modal (QRIS Simulation) -->
  @if (isCheckoutModalOpen) {
    <!-- Payment Modal -->
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        class="absolute inset-0 bg-black/70 backdrop-blur-md"
        (click)="promptClosePayment()"
      ></div>
      <div
        class="relative bg-white rounded-[2rem] w-full max-w-sm p-6 shadow-2xl animate-fade-in-up flex flex-col items-center text-center border-4 border-blue-50"
      >
        @if (qrisStatus === "waiting") {
          <!-- Header -->
          <h3 class="text-xl font-black text-gray-900 mb-1">Pembayaran QRIS</h3>
          <p class="text-sm text-gray-500 mb-4 font-medium">
            Scan QR code di bawah menggunakan aplikasi pembayaran favoritmu
          </p>

          <!-- Timer -->
          @if (paymentCountdown) {
            <div
              class="bg-red-50 text-red-600 px-4 py-2 rounded-full font-bold text-sm mb-6 flex items-center gap-2 border border-red-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Batas Waktu: {{ paymentCountdown }}
            </div>
          }

          <!-- QR Code Box -->
          <div
            class="bg-white p-3 rounded-2xl shadow-[0_0_15px_rgba(0,0,0,0.1)] border-2 border-gray-100 mb-6 relative"
          >
            <img
              [src]="paymentQrUrl || '/assets/qris_dummy.png'"
              alt="QRIS Payment"
              class="w-48 h-48 object-contain rounded-xl"
              onerror="
                this.src =
                  'https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg'
              "
            />
            @if (isCheckoutLoading) {
              <!-- Loading Overlay inside QR -->
              <div
                class="absolute inset-0 bg-white/50 backdrop-blur-[2px] flex flex-col items-center justify-center rounded-xl"
              >
                <div
                  class="animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent mb-2"
                ></div>
                <span class="text-blue-500 font-bold text-xs text-center px-4">
                  Memproses...
                </span>
              </div>
            }
          </div>

          <!-- Amount -->
          <p class="text-sm text-gray-500 font-medium mb-1">Total Pembayaran</p>
          <h2 class="text-3xl font-black text-blue-600 mb-6">
            {{ formatPrice(paymentAmount) }}
          </h2>

          @if (checkoutError) {
            <p
              class="mb-4 rounded-xl bg-red-50 p-3 text-xs font-semibold text-red-600 w-full text-center"
            >
              {{ checkoutError }}
            </p>
          }

          <!-- Actions -->
          <button
            (click)="promptClosePayment()"
            class="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-4 rounded-xl transition-all active:scale-95 text-base flex justify-center items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Tutup
          </button>
        } @else {
          <!-- Success state -->
          <h3 class="text-xl font-black text-gray-900 mb-1 mt-4">Berhasil!</h3>
          <p class="text-sm text-gray-500 mb-6 font-medium">
            Pembayaran kamu sudah masuk
          </p>

          <div
            class="bg-green-50 p-6 rounded-3xl border-2 border-green-200 mb-6 flex flex-col items-center justify-center w-full shadow-inner"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-24 w-24 text-green-500 mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span class="text-green-600 font-bold text-lg text-center"
              >Pembayaran Sukses</span
            >
          </div>

          <button
            (click)="closeCheckout()"
            class="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-xl transition-colors shadow-lg"
          >
            Selesai
          </button>
        }
      </div>
    </div>
  }

  <!-- Cancel Payment Confirmation Popup -->
  @if (isCancelPaymentModalOpen) {
    <div class="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        class="absolute inset-0 bg-black/60 backdrop-blur-sm"
        (click)="cancelClosePayment()"
      ></div>
      <div
        class="relative bg-white rounded-3xl w-full max-w-sm p-6 shadow-2xl animate-fade-in-up flex flex-col items-center text-center"
      >
        <div
          class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h3 class="text-xl font-bold text-gray-900 mb-2">
          Batalkan Pembayaran?
        </h3>
        <p class="text-gray-600 font-medium mb-6">
          Kamu yakin ingin membatalkan pembayaran ini?
        </p>

        <div class="w-full flex gap-3 mt-2">
          <button
            (click)="cancelClosePayment()"
            class="flex-1 border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-gray-600 font-bold py-3 px-4 rounded-xl transition-all"
          >
            Tidak
          </button>
          <button
            (click)="confirmClosePayment()"
            class="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-xl shadow-lg transition-all"
          >
            Ya, Batalkan
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Transaction detail modal -->
  @if (isTransactionModalOpen) {
    <div
      id="transaction-modal"
      (click)="closeTransactionModal()"
      class="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="transaction-title"
    >
      <div
        (click)="$event.stopPropagation()"
        class="relative w-full max-w-md max-h-[88vh] flex flex-col rounded-[24px] sm:rounded-[28px] bg-white text-neutral-900 shadow-2xl overflow-hidden border border-neutral-100 animate-scale-in"
      >
        <!-- Header -->
        <div
          class="flex items-center justify-between border-b border-neutral-100 px-5 sm:px-6 py-4 flex-shrink-0 bg-white z-10"
        >
          <div>
            <p
              class="text-[10px] font-bold uppercase tracking-[0.2em] text-blue-500"
            >
              Receipt & order
            </p>
            <h2
              id="transaction-title"
              class="mt-0.5 text-lg sm:text-xl font-extrabold text-neutral-900"
            >
              Detail Transaksi
            </h2>
          </div>
          <button
            id="close-transaction"
            type="button"
            (click)="closeTransactionModal()"
            class="rounded-full p-2 text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100 transition-colors"
            aria-label="Tutup detail transaksi"
          >
            ✕
          </button>
        </div>

        <!-- Scrollable Modal Body -->
        <div
          class="overflow-y-auto px-5 sm:px-6 py-4 flex-1 overscroll-contain [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-neutral-200 hover:[&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent"
        >
          <!-- Order Metadata Grid -->
          <div class="grid grid-cols-2 gap-2 sm:gap-2.5 text-xs">
          <div class="rounded-2xl bg-neutral-50 p-2.5 sm:p-3 border border-neutral-100 flex flex-col justify-center">
            <span
              class="block text-[10px] text-neutral-400 font-semibold uppercase tracking-wider mb-0.5"
              >Invoice</span
            >
            <strong class="text-neutral-800 font-bold break-all text-[11px] sm:text-xs leading-snug">{{
              order.invoice || sessionData?.invoice || "-"
            }}</strong>
          </div>
          <div class="rounded-2xl bg-neutral-50 p-2.5 sm:p-3 border border-neutral-100 flex flex-col justify-center">
            <span
              class="block text-[10px] text-neutral-400 font-semibold uppercase tracking-wider mb-0.5"
              >Status</span
            >
            <span
              class="inline-flex items-center self-start px-2 py-0.5 rounded-full text-[10px] font-extrabold capitalize bg-emerald-100 text-emerald-700"
            >
              {{ transactionData?.status || order.status || "Paid" }}
            </span>
          </div>
          <div class="rounded-2xl bg-neutral-50 p-2.5 sm:p-3 border border-neutral-100 flex flex-col justify-center">
            <span
              class="block text-[10px] text-neutral-400 font-semibold uppercase tracking-wider mb-0.5"
              >Nama</span
            >
            <strong class="text-neutral-800 font-bold break-words text-[11px] sm:text-xs leading-snug">{{
              order.name || sessionData?.name || "-"
            }}</strong>
          </div>
          <div class="rounded-2xl bg-neutral-50 p-2.5 sm:p-3 border border-neutral-100 flex flex-col justify-center">
            <span
              class="block text-[10px] text-neutral-400 font-semibold uppercase tracking-wider mb-0.5"
              >PIN Order</span
            >
            <strong class="text-blue-600 font-black tracking-widest break-all text-[11px] sm:text-xs leading-snug">{{
              order.order_pin || "-"
            }}</strong>
          </div>
          <div class="col-span-2 rounded-2xl bg-neutral-50 p-2.5 sm:p-3 border border-neutral-100 flex flex-col justify-center">
            <span
              class="block text-[10px] text-neutral-400 font-semibold uppercase tracking-wider mb-0.5"
              >Waktu Transaksi</span
            >
            <strong class="text-neutral-800 font-bold break-words text-[11px] sm:text-xs leading-snug">
              @if (transactionTime) {
                {{ transactionTime | date: "dd MMM yyyy, HH:mm:ss" }}
              } @else {
                -
              }
            </strong>
          </div>
        </div>

        @if (transactionData?.id || transactionData?.transaction_id) {
          <div
            class="mt-3 rounded-2xl bg-neutral-50 border border-neutral-100 p-2.5 sm:p-3 text-xs flex justify-between items-center gap-2"
          >
            <span class="text-neutral-400 font-medium shrink-0">Transaction ID</span>
            <strong class="text-neutral-700 font-mono text-[10px] sm:text-[11px] break-all text-right">{{
              transactionData.id || transactionData.transaction_id
            }}</strong>
          </div>
        }

        <!-- Main Purchased Items Section (Paket Foto Utama) -->
        @if (mainPurchasedItems.length > 0) {
          <div class="mt-5 border-t border-neutral-100 pt-4">
            <h3
              class="text-[11px] font-extrabold uppercase tracking-wider text-blue-600 mb-3 flex items-center justify-between"
            >
              <span class="flex items-center gap-1.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                  />
                </svg>
                Item Paket Foto
              </span>
              <span
                class="text-[10px] font-bold text-blue-700 bg-blue-50 border border-blue-100 px-2 py-0.5 rounded-full"
              >
                {{ mainPurchasedItems.length }} Item
              </span>
            </h3>

            <div class="space-y-3">
              @for (item of mainPurchasedItems; track item.id || $index) {
                <div
                  class="rounded-2xl bg-blue-50/40 border border-blue-100/80 p-3 sm:p-3.5 text-xs flex flex-col gap-2 shadow-sm"
                >
                  <!-- Product Title & Price -->
                  <div class="flex items-start justify-between gap-2">
                    <div class="flex flex-col min-w-0 flex-1">
                      <strong
                        class="text-blue-900 font-extrabold text-xs sm:text-sm break-words leading-snug"
                      >
                        {{
                          formatProductName(
                            item.product_name ||
                              item.details?.product_name ||
                              "Paket Foto"
                          )
                        }}
                      </strong>
                      @if (item.product_sku || item.details?.product_sku) {
                        <span class="text-[10px] text-neutral-400 font-mono break-all mt-0.5"
                          >SKU: {{ item.product_sku || item.details?.product_sku }}</span
                        >
                      }
                      @if (item.created_at) {
                        <span class="text-[10px] text-neutral-400 font-medium mt-0.5"
                          >Waktu: {{ item.created_at | date: "dd MMM yyyy, HH:mm:ss" }}</span
                        >
                      }
                    </div>
                    <span
                      class="text-neutral-800 font-extrabold whitespace-nowrap text-xs sm:text-sm shrink-0 ml-2"
                    >
                      {{
                        formatPrice(item.product_price ?? item.sub_total ?? 0)
                      }}
                    </span>
                  </div>

                  <!-- Voucher / Discount Line inside Item -->
                  @if (
                    item.voucher_name ||
                    item.discount_source_details?.has_voucher ||
                    item.discount > 0
                  ) {
                    <div
                      class="flex items-center justify-between pt-2 border-t border-blue-100/60 text-[10px] sm:text-[11px] gap-2"
                    >
                      <div
                        class="flex items-center gap-1.5 text-amber-700 bg-amber-50 px-2 py-0.5 rounded-md border border-amber-200/60 font-semibold min-w-0 flex-1"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-3 h-3 text-amber-500 shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                          />
                        </svg>
                        <span class="break-words leading-tight text-[10px] sm:text-[11px]">{{
                          item.voucher_name ||
                            item.discount_source_details?.voucher_name ||
                            "Voucher"
                        }}</span>
                      </div>
                      <span
                        class="text-red-500 font-bold shrink-0 text-[10px] sm:text-[11px] whitespace-nowrap"
                      >
                        -{{ formatPrice(item.discount || item.discount_source_details?.voucher_discount || 0) }}
                      </span>
                    </div>
                  }

                  <!-- Promo Line if any -->
                  @if (
                    item.discount_source_details?.has_promo &&
                    item.discount_source_details?.promo_name
                  ) {
                    <div
                      class="flex items-center justify-between text-[10px] sm:text-[11px] gap-2"
                    >
                      <div
                        class="flex items-center gap-1.5 text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-md border border-emerald-200/60 font-semibold min-w-0 flex-1"
                      >
                        <span class="break-words leading-tight text-[10px] sm:text-[11px]"
                          >🏷️
                          {{ item.discount_source_details.promo_name }}</span
                        >
                      </div>
                      <span
                        class="text-red-500 font-bold shrink-0 text-[10px] sm:text-[11px] whitespace-nowrap"
                      >
                        -{{
                          formatPrice(
                            item.discount_source_details.promo_discount || 0
                          )
                        }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- Add-on Purchased Items Section (Pembelian Add-on / Tambahan) -->
        @if (purchasedAddonItems.length > 0) {
          <div class="mt-5 border-t border-neutral-100 pt-4">
            <h3
              class="text-[11px] font-extrabold uppercase tracking-wider text-pink-600 mb-3 flex items-center justify-between"
            >
              <span class="flex items-center gap-1.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 text-pink-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6v12m6-6H6"
                  />
                </svg>
                Pembelian Add-on / Tambahan
              </span>
              <span
                class="text-[10px] font-bold text-pink-700 bg-pink-50 border border-pink-100 px-2 py-0.5 rounded-full"
              >
                {{ purchasedAddonItems.length }} Add-on
              </span>
            </h3>

            <div class="space-y-3">
              @for (addon of purchasedAddonItems; track addon.id || $index) {
                <div
                  class="rounded-2xl bg-pink-50/40 border border-pink-100/80 p-3 sm:p-3.5 text-xs flex flex-col gap-2 shadow-sm"
                >
                  <!-- Addon Title & Price -->
                  <div class="flex items-start justify-between gap-2">
                    <div class="flex flex-col min-w-0 flex-1">
                      <div class="flex items-center gap-1.5 flex-wrap">
                        <span
                          class="bg-pink-500 text-white text-[9px] font-black px-1.5 py-0.5 rounded uppercase tracking-wider shrink-0"
                          >Add-on</span
                        >
                        <strong
                          class="text-pink-900 font-extrabold text-xs sm:text-sm break-words leading-snug"
                        >
                          {{ formatProductName(addon.product_name || addon.name || "Add-on Photobooth") }}
                        </strong>
                      </div>
                      @if (addon.qty && addon.qty > 1) {
                        <span class="text-[10px] text-pink-600 font-semibold mt-0.5">
                          Qty: {{ addon.qty }}x
                        </span>
                      }
                      @if (addon.product_sku) {
                        <span class="text-[10px] text-neutral-400 font-mono break-all mt-0.5"
                          >SKU: {{ addon.product_sku }}</span
                        >
                      }
                      @if (addon.invoice) {
                        <span class="text-[10px] text-neutral-400 font-mono mt-0.5 break-all"
                          >Inv: {{ addon.invoice }}</span
                        >
                      }
                      @if (addon.created_at) {
                        <span class="text-[9px] text-neutral-400 font-medium"
                          >{{ addon.created_at | date: "dd MMM yyyy, HH:mm" }}</span
                        >
                      }
                    </div>
                    <div class="text-right shrink-0 ml-2">
                      <span
                        class="text-neutral-800 font-extrabold whitespace-nowrap text-xs sm:text-sm block"
                      >
                        {{
                          formatPrice(addon.sub_total || addon.product_price || addon.total || 0)
                        }}
                      </span>
                      <span
                        class="inline-block text-[9px] font-bold text-emerald-700 bg-emerald-100 border border-emerald-200 px-2 py-0.5 rounded-full mt-0.5 whitespace-nowrap"
                        >{{ addon.status || "Paid" }}</span
                      >
                    </div>
                  </div>

                  <!-- Voucher / Discount Line inside Addon -->
                  @if (addon.discount > 0 || addon.voucher_name) {
                    <div
                      class="flex items-center justify-between pt-2 border-t border-pink-100/60 text-[10px] sm:text-[11px] gap-2"
                    >
                      <div
                        class="flex items-center gap-1.5 text-amber-700 bg-amber-50 px-2 py-0.5 rounded-md border border-amber-200/60 font-semibold min-w-0 flex-1"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-3 h-3 text-amber-500 shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                          />
                        </svg>
                        <span class="break-words leading-tight text-[10px] sm:text-[11px]">{{
                          addon.voucher_name || "Voucher Diskon"
                        }}</span>
                      </div>
                      <span
                        class="text-red-500 font-bold shrink-0 text-[10px] sm:text-[11px] whitespace-nowrap"
                      >
                        -{{ formatPrice(addon.discount) }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- Payment Calculation Summary -->
        <div
          class="mt-5 border-t border-neutral-100 pt-4 flex flex-col gap-2.5 text-[11px] sm:text-xs"
        >
          <!-- Subtotal Paket Utama -->
          <div class="flex justify-between items-center text-neutral-500 gap-2">
            <span class="break-words flex-1">Subtotal Paket Foto</span>
            <span class="font-bold text-neutral-700 whitespace-nowrap shrink-0">
              {{ formatPrice(orderSubtotal) }}
            </span>
          </div>

          <!-- Subtotal Add-on (if any) -->
          @if (purchasedAddonItems.length > 0) {
            <div class="flex justify-between items-center text-pink-700 gap-2">
              <span class="font-semibold break-words flex-1">Subtotal Pembelian Add-on</span>
              <span class="font-bold text-pink-800 whitespace-nowrap shrink-0">
                +{{ formatPrice(addonSubtotal) }}
              </span>
            </div>
          }

          <!-- Total Voucher / Discount -->
          @if (orderDiscount > 0 || addonDiscount > 0 || orderVoucherName) {
            <div
              class="flex justify-between items-center text-amber-700 text-[10px] sm:text-xs gap-2"
            >
              <div class="flex items-center gap-1.5 font-semibold min-w-0 flex-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-3.5 h-3.5 text-amber-500 shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                  />
                </svg>
                <span class="break-words leading-tight">
                  Diskon Voucher
                  @if (orderVoucherName) {
                    ({{ orderVoucherName }})
                  }
                </span>
              </div>
              <span class="font-extrabold text-red-500 shrink-0 whitespace-nowrap">
                -{{ formatPrice(orderDiscount + addonDiscount) }}
              </span>
            </div>
          }

          <!-- Tax -->
          @if (orderTax > 0) {
            <div class="flex justify-between items-center text-neutral-500 gap-2">
              <span class="break-words flex-1">Pajak (Tax)</span>
              <span class="font-bold text-neutral-700 whitespace-nowrap shrink-0">{{
                formatPrice(orderTax)
              }}</span>
            </div>
          }

          <!-- Total Final -->
          <div
            class="mt-2 rounded-2xl bg-blue-600 p-4 flex justify-between items-center text-white shadow-lg shadow-blue-600/20 gap-3"
          >
            <div class="min-w-0 flex-1">
              <span
                class="block text-[10px] uppercase font-bold text-blue-100 tracking-wider"
                >Total Pembayaran</span
              >
              <span class="text-xs text-blue-100/90 font-medium break-words leading-snug block"
                >Sudah Termasuk Add-on & Diskon</span
              >
            </div>
            <strong class="text-lg sm:text-xl font-black tracking-tight text-white whitespace-nowrap shrink-0">
              {{ formatPrice(overallGrandTotal) }}
            </strong>
          </div>

          <!-- Download PDF Struk Button -->
          <button
            id="download-receipt-pdf"
            type="button"
            (click)="downloadReceiptPdf()"
            class="mt-3 w-full bg-red-600 hover:bg-red-700 text-white py-3.5 px-4 rounded-2xl font-black text-xs sm:text-sm shadow-md shadow-red-600/20 hover:shadow-lg active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 sm:w-5 sm:h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <span>Download PDF Struk / Nota Pesanan</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}

  @if (isDownloading) {
    <div
      class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-md p-4 animate-fade-in"
    >
      <div
        class="bg-white border-2 border-pink-100 text-slate-800 rounded-3xl p-6 sm:p-8 max-w-sm sm:max-w-md w-full shadow-2xl flex flex-col items-center gap-4 text-center animate-scale-in"
      >
        <!-- Circular Progress Indicator with Fotokapsul Pink/Blue Ring -->
        <div
          class="relative w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center"
        >
          <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
            <path
              class="text-blue-100"
              stroke-width="3.5"
              stroke="currentColor"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              class="text-pink-500 transition-all duration-300 ease-out"
              [attr.stroke-dasharray]="downloadProgress + ', 100'"
              stroke-linecap="round"
              stroke-width="3.5"
              stroke="currentColor"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <span
            class="absolute text-base sm:text-lg font-black text-blue-600"
          >
            {{ downloadProgress }}%
          </span>
        </div>

        <!-- Progress Labels -->
        <div class="w-full space-y-1">
          <h3
            class="text-lg sm:text-xl font-black tracking-tight text-slate-900 flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 sm:w-6 sm:h-6 text-pink-500 shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Mengunduh Foto</span>
          </h3>
          <p
            class="text-xs sm:text-sm text-slate-600 font-semibold truncate max-w-full px-2"
          >
            {{ downloadStatusText }}
          </p>
          @if (downloadTotalCount > 0) {
            <span
              class="inline-block text-xs font-black text-pink-600 bg-pink-50 border border-pink-200 px-3.5 py-1 rounded-full shadow-xs mt-1"
            >
              {{ downloadCompletedCount }} dari {{ downloadTotalCount }} Foto
              Selesai
            </span>
          }
        </div>

        <!-- Progress Bar (Pink/Blue Gradient) -->
        <div
          class="w-full bg-slate-100 h-3 rounded-full overflow-hidden mt-1 border border-slate-200 shadow-inner p-0.5"
        >
          <div
            class="bg-blue-600 h-full rounded-full transition-all duration-300 shadow-sm"
            [style.width.%]="downloadProgress"
          ></div>
        </div>
      </div>
    </div>
  }
</div>
